import React from 'react';
import TabContainer from '../../../../../../common/components/tab/containers/tab.containers';
import VoucherBasicInfoComponent from './voucher-basic-info.component';
import VoucherItemInfoComponent from './voucher-item-info.component';

export const VoucherComponent = ({
  handleInnerFormChange, selectedVouchers, back, handleFormSubmit,
  voucherTransactionTypeList, voucherSourceOfPaymentList,
  paymentTransactionTypeList, bankConfigurationsList, paymentReferanceTypeList,
  organizationUnitsList, ledgersList, supplierNameList,
  invoiceNumbersList
}: any) => {

  const tabItems = [
    {
      id: 0,
      title: 'Voucher Basic Information',
      component: <VoucherBasicInfoComponent
        handleInnerFormChange={handleInnerFormChange}
        selectedVouchers={selectedVouchers}
        voucherTransactionTypeList={voucherTransactionTypeList}
        voucherSourceOfPaymentList={voucherSourceOfPaymentList}
        paymentTransactionTypeList={paymentTransactionTypeList}
        bankConfigurationsList={bankConfigurationsList}
        paymentReferanceTypeList={paymentReferanceTypeList}
        organizationUnitsList={organizationUnitsList}
        ledgersList={ledgersList}
        supplierNameList={supplierNameList}
      />,
      isVisible: true,
    },
    {
      id: 1,
      title: 'Voucher Item Information',
      component: <VoucherItemInfoComponent
        handleInnerFormChange={handleInnerFormChange}
        selectedVouchers={selectedVouchers}
        invoiceNumbersList={invoiceNumbersList}
      />,
      isVisible: true,
    },
  ]

  return (
    <div className="flex flex-col items-center w-full px-5 h-[620px] overflow-auto">

      <TabContainer tabItems={tabItems} />

      <div className='flex w-full justify-end items-end'>
        <button
          onClick={back}
          type='button'
          className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
        >
          Back
        </button>
        <button
          className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
          onClick={handleFormSubmit}
          type="submit"
        >
          Save
        </button>
      </div>
    </div>
  )
}

export default VoucherComponent;
